import SectionHeading from "./SectionHeading";
import { safetyItems } from "@/mocks/homeContent";

export default function Safety() {
  return (
    <section id="safety" className="w-full py-16 md:py-24 bg-foreground-950">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Safety"
          title="下载与安装安全提示"
          desc="安装包的安全性同样重要。遵循以下四点，可以最大程度避免下载到被篡改的版本，保护设备与个人信息。"
          light
        />

        <div className="max-w-6xl mx-auto mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {safetyItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-50/5 border border-background-50/15 rounded-lg p-6"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500/20 text-primary-300 flex items-center justify-center">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/80 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}